module Shared.Home.UpdatePassword

open Shared.PasswordReset.ResetPassword
open Illy.SafeStack

type DTO = 
    {
        CurrentPassword: string option
        NewPassword: string option 
        ConfirmNewPassword: string option
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.CompositionalValidation
    open Shared.PasswordReset.ResetPassword.Validations

    type UpdatePasswordValidations = 
        | CurrentPasswordValidations of Shared.Validations.Password.PasswordValidations
        | NewPasswordValidations of PasswordValidations
        | ConfirmPasswordValidations of ConfirmPasswordValidations

    module UpdatePasswordValidations = 
        let toString = 
            function 
            | CurrentPasswordValidations v -> Shared.Validations.Password.PasswordValidations.toString v
            | NewPasswordValidations v -> PasswordValidations.toString v
            | ConfirmPasswordValidations v -> ConfirmPasswordValidations.toString v
    
    let validateDTO scorePassword pwdConfig (dto: DTO) = 
        validate {
            return! (Shared.Validations.Password.validatePassword >-> UpdatePasswordValidations.CurrentPasswordValidations) dto.CurrentPassword
            return! (validatePassword scorePassword pwdConfig >-> UpdatePasswordValidations.NewPasswordValidations) dto.NewPassword
            return! (validateConfirmPassword pwdConfig.PasswordStrength dto.NewPassword >-> UpdatePasswordValidations.ConfirmPasswordValidations) dto.ConfirmNewPassword
        }

type FailureReason = 
    | FailedValidations of Validation.ValidationResult<Validations.UpdatePasswordValidations, Validation.NoWarning>